import { FavoriteIcon } from 'components/icons';
import { Tooltip } from 'components/ui';
import querystring from 'querystring';
import { useAppSelector } from 'store';
import { composableFiltersState } from 'store/composableFiltersSlice';
import {
  useGetCustomerSegmentsQuery,
  useUpdateSegmentMutation,
} from 'store/services/segmentsApi';
import { userDetailsState } from 'store/userDetailsSlice';
import { useParseURLQueryParams } from 'utils';

export const FavoriteSegment = () => {
  const { rawQueryParams } = useParseURLQueryParams();

  const queryParams = querystring.stringify({
    store_name: rawQueryParams?.store_name,
  });

  const { currentStore } = useAppSelector(userDetailsState);

  const { selected } = useAppSelector(composableFiltersState);

  const [updateSegment] = useUpdateSegmentMutation();

  const { data: segments } = useGetCustomerSegmentsQuery(
    { serializedStoreName: currentStore.serializedStoreName },
    {
      skip: !!!currentStore.serializedStoreName,
    }
  );

  const currentSelectedSegment = segments?.find(
    (item) => item.id === selected.segment?.id
  );

  function toggleFavorite() {
    const body = {
      favorite: String(!!!currentSelectedSegment?.favorite),
    };

    updateSegment({
      body,
      segmentId: Number(currentSelectedSegment?.id),
      serializedStoreName: queryParams,
    });
  }

  return (
    <button className="px-3" onClick={toggleFavorite}>
      <Tooltip text="Favorite segment">
        <FavoriteIcon
          className="w-5 h-5 text-segments-accent-color-orange"
          selected={currentSelectedSegment?.favorite}
        />
      </Tooltip>
    </button>
  );
};
